import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Controller } from "react-hook-form";
import SaveIcon from "@mui/icons-material/Save";
import { green } from "@mui/material/colors";

interface PropsType {
  registerTimesheet: any;
  handleTimesheetSubmit: any;
  onTimesheetFormSubmit: any;
  timesheeErrors: any;
  controlTimesheet: any;
  weekDaysName: any;
  loading: any;
}

export default function TimesheetConfiguration(props: PropsType) {
  const {
    registerTimesheet,
    handleTimesheetSubmit,
    onTimesheetFormSubmit,
    timesheeErrors,
    controlTimesheet,
    weekDaysName,
    loading,
  } = props;

  return (
    <Grid
      container
      sx={{
        backgroundColor: "background.paper",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box>
        <Typography variant="h5" m={2}>
          Timesheet Settings
        </Typography>
      </Box>
      <Box
        component="form"
        sx={{
          "& .MuiTextField-root": { ml: 1 },
        }}
        noValidate
        autoComplete="off"
        onSubmit={handleTimesheetSubmit(onTimesheetFormSubmit)}
      >
        <Grid container rowGap={2}>
          <Grid item aria-label="shift-time-container" xs={12} rowGap={2}>
            <TextField
              id="morning-shift"
              label="Morning Shift"
              required
              InputLabelProps={{
                shrink: true,
              }}
              {...registerTimesheet("morning_shift")}
              error={!!timesheeErrors["morning_shift"]}
              helperText={
                timesheeErrors["morning_shift"]
                  ? timesheeErrors["morning_shift"].message
                  : "Note: Format Time: HH-HH"
              }
            />
            <TextField
              id="evening-shift"
              label="Evening Shift"
              required
              InputLabelProps={{
                shrink: true,
              }}
              {...registerTimesheet("evening_shift")}
              error={!!timesheeErrors["evening_shift"]}
              helperText={
                timesheeErrors["evening_shift"]
                  ? timesheeErrors["evening_shift"].message
                  : "Note: Format Time: HH-HH"
              }
            />
            <TextField
              required
              id="night-shift"
              label="Night Shift"
              InputLabelProps={{
                shrink: true,
              }}
              {...registerTimesheet("night_shift")}
              error={!!timesheeErrors["night_shift"]}
              helperText={
                timesheeErrors["night_shift"]
                  ? timesheeErrors["night_shift"].message
                  : "Note: Format Time: HH-HH"
              }
            />
          </Grid>

          <Grid container aria-label="shift-start-day-container" spacing={2}>
            <Grid item>
              <FormControl
                className="custom_select"
                sx={{ ml: 1, mt: 2, width: 200, marginTop: 0 }}
                variant="outlined"
              >
                <InputLabel id="status-select-label" className="mb-2">
                  Shift Start Day *
                </InputLabel>
                <Controller
                  name="start_day"
                  control={controlTimesheet}
                  defaultValue={1}
                  render={({ field: { onChange, value } }) => (
                    <Select
                      defaultValue={1}
                      className="input-container"
                      id="shift-start-day"
                      size="small"
                      disabled={!weekDaysName?.length}
                      onChange={onChange}
                      value={value}
                      label="Shift Start Day *"
                      sx={{ height: 57 }}
                    >
                      {weekDaysName.map((c: any, i: number) => (
                        <MenuItem key={`c-${i}`} value={c.id}>
                          {c.name}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="working_hours_limit"
                label="Working Hour Limit "
                type="number"
                sx={{ ml: 1, mt: 2, width: 200, marginTop: 0 }}
                // required
                InputLabelProps={{
                  shrink: true,
                }}
                {...registerTimesheet("working_hours_limit")}
                error={!!timesheeErrors["working_hours_limit"]}
                helperText={"Note: Format Time: HH"}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} sx={{ ml: 1, mt: 1 }}>
            <Box sx={{ m: 1, position: "relative" }}>
              <Button
                type="submit"
                variant="contained"
                color="success"
                startIcon={<SaveIcon />}
                disabled={loading}
              >
                Save
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: green[500],
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
}
